
// MÉTODO PARA OBTENER PERMISOS DE CENTROS
export async function get_centers_access(servidor) {
  const SERVER_URL = servidor
  const endpoint   = `${SERVER_URL}/scapp_get_centers_access`;
  // console.log('SCAAP scapp_get_centers_access →', endpoint);

  try {
    const response = await fetch(endpoint, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      keepalive: false
    });

    // Si quieres ver el status o las cabeceras:
    // console.log('[get_centers_access] status:', response.status);

    // Lee el cuerpo **una sola vez**, aquí:
    const data = await response.json();
    // console.log('[get_centers_access] data:', data);

    if (!response.ok) {
      throw new Error(data.mensaje || "Error al obtener permisos de centros");
    }

    return data;
  } catch (error) {
    console.error("Error al obtener permisos de los centros:", error);
    throw error;
  }
}


// METODO DE CONSULTA DE DATOS DE la REGION  get_data
export async function get_data_region_scapp(REGION, FECHA, CANTIDAD_DIAS, servidor) {

    let SERVER_URL = servidor
    const endpoint = `${SERVER_URL}/scapp/get_analytic_region_data/${REGION}/${FECHA}/${CANTIDAD_DIAS}`;
    console.log('SCAAP get_data 1 ->', endpoint);

    let data

    try {
        console.log('SCAAP get_data ->', endpoint);
        const response = await fetch(endpoint, {
        // const response = await fetch(`${SERVER_URL}/get_data/${"Aysen"}/${"Melinka"}/${"Cacere0s"}`, {

            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
                
            },
            keepalive: false  // Asegura cerrar la conexión después de que se haya completado la solicitud
        });

        data = await response.json();

        console.log('data',data)
        console.log(response)

        if (!response.ok) {
            throw new Error(data.mensaje || "Error intentando  acceder al centro");
        }

        return data;


    } catch (error) {
        console.error("Hubo un error al acceder al centro:", error);
        throw error;
    }
}
//? METODO DE CONSULTA DE DATOS DE la AREA  get_data
export async function get_data_area_scapp(REGION, AREA, FECHA, CANTIDAD_DIAS, servidor) {
  console.log('ruta area')
    // let Local_URL = 'http://172.16.2.195:7777'
    let SERVER_URL = servidor
    const endpoint = `${SERVER_URL}/scapp/get_analytic_area_data/${REGION}/${AREA}/${FECHA}/${CANTIDAD_DIAS}`;
    console.log('SCAAP get_data 1 ->', endpoint);

    let data

    try {
        console.log('SCAAP get_data ->', endpoint);
        const response = await fetch(endpoint, {
        // const response = await fetch(`${SERVER_URL}/get_data/${"Aysen"}/${"Melinka"}/${"Cacere0s"}`, {

            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
                
            },
            keepalive: false  // Asegura cerrar la conexión después de que se haya completado la solicitud
        });

        data = await response.json();

        console.log('data',data)
        console.log(response)

        if (!response.ok) {
            throw new Error(data.mensaje || "Error intentando  acceder al centro");
        }

        return data;


    } catch (error) {
        console.error("Hubo un error al acceder al centro:", error);
        throw error;
    }
}
// METODO DE CONSULTA DE DATOS DEL CENTRO  get_data
export async function get_data_scapp(REGION, AREA, CENTRO, FECHA, CANTIDAD_DIAS, servidor) {

    let SERVER_URL = servidor;
    const endpoint = `${SERVER_URL}/scapp/get_analytic_center_data/${REGION}/${AREA}/${CENTRO}/${FECHA}/${CANTIDAD_DIAS}`;
    console.log('SCAAP get_data 1 ->', endpoint);

    let data

    try {
        console.log('SCAAP get_data ->', endpoint);
        const response = await fetch(endpoint, {
        // const response = await fetch(`${SERVER_URL}/get_data/${"Aysen"}/${"Melinka"}/${"Cacere0s"}`, {

            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
                
            },
            keepalive: false  // Asegura cerrar la conexión después de que se haya completado la solicitud
        });

        data = await response.json();

        // console.log('data',data)
        // console.log(response)

        if (!response.ok) {
            throw new Error(data.mensaje || "Error intentando  acceder al centro");
        }

        return data;


    } catch (error) {
        console.error("Hubo un error al acceder al centro:", error);
        throw error;
    }
}

async function get_feeder_score(endpoint) {
  let response;
  try {
    response = await fetch(endpoint, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      keepalive: false,
    });
  } catch (networkError) {
    console.error('[FeederScore] Error de red al llamar', endpoint, networkError);
    throw new Error('No se pudo conectar con el servidor de FeederScore.');
  }

  // Leemos el cuerpo como texto primero: un 401/redirect a login suele devolver
  // HTML, no JSON, y response.json() reventaría con un SyntaxError opaco.
  const rawBody = await response.text();
  let data = {};
  try {
    data = rawBody ? JSON.parse(rawBody) : {};
  } catch (parseError) {
    console.error('[FeederScore] Respuesta no-JSON', response.status, endpoint, rawBody.slice(0, 200));
    if (response.status === 401 || response.status === 403) {
      throw new Error('Sesión expirada o sin permisos. Vuelve a iniciar sesión.');
    }
    throw new Error(`Respuesta inválida del servidor (HTTP ${response.status}).`);
  }

  if (!response.ok) {
    console.error('[FeederScore] HTTP', response.status, endpoint, data);
    if (response.status === 401 || response.status === 403) {
      throw new Error('Sesión expirada o sin permisos. Vuelve a iniciar sesión.');
    }
    throw new Error(data.mensaje || data.Error || `Error al acceder a FeederScore (HTTP ${response.status}).`);
  }

  return data?.feeder_score_data || {};
}

export async function get_feeder_score_center(REGION, AREA, CENTRO, FECHA, CANTIDAD_DIAS, servidor) {
  const endpoint = `${servidor}/scapp/get_feeder_score_center_data/${REGION}/${AREA}/${CENTRO}/${FECHA}/${CANTIDAD_DIAS}`;
  return get_feeder_score(endpoint);
}

export async function get_feeder_score_area(REGION, AREA, FECHA, CANTIDAD_DIAS, servidor) {
  const endpoint = `${servidor}/scapp/get_feeder_score_area_data/${REGION}/${AREA}/${FECHA}/${CANTIDAD_DIAS}`;
  return get_feeder_score(endpoint);
}

export async function get_feeder_score_region(REGION, FECHA, CANTIDAD_DIAS, servidor, options = {}) {
  const query = options.granularity ? `?granularity=${encodeURIComponent(options.granularity)}` : '';
  const endpoint = `${servidor}/scapp/get_feeder_score_region_data/${REGION}/${FECHA}/${CANTIDAD_DIAS}${query}`;
  return get_feeder_score(endpoint);
}

// /scapp/compare_analytic_centers?centros=Loslagos-Puertomontt-Itg,Loslagos-Puertomontt-Nanoox&start_day=5-5-2025&day_ranges=7

// `${SERVER_URL}//scapp/compare_analytic_centers?centros=Loslagos-Puertomontt-Itg,Loslagos-Puertomontt-Nanoox&start_day=10-05-2025&day_ranges=1
// MÉTODO PARA COMPARAR DATOS DE VARIOS CENTROS
/**
 * Llama al endpoint de comparación de centros con query params.
 * @param {string} centros   — string con centros separados por coma
 * @param {string} start_day — fecha de inicio en formato DD-MM-YYYY
 * @param {number} day_ranges — rango de días (entero)
 */
export async function compare_analytic_areas(areas, start_day, day_ranges, servidor) {
  const SERVER_URL = servidor
  const Local ='http://172.16.2.195:7777'

  const endpoint = `${servidor}/scapp/compare_analytic_areas`
    + `?areas=${areas}`
    + `&start_day=${encodeURIComponent(start_day)}`
    + `&day_ranges=${encodeURIComponent(day_ranges)}`;

  console.log('API compare_analytic_areas ->', endpoint);

  const resp = await fetch(endpoint, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    keepalive: false
  });

  const data = await resp.json();
  if (!resp.ok) {
    throw new Error(data.mensaje || 'Error al comparar areas');
  }
  return data;
}





// MÉTODO PARA COMPARAR DATOS DE VARIOS CENTROS
/**
 * Llama al endpoint de comparación de centros con query params.
 * @param {string} centros   — string con centros separados por coma
 * @param {string} start_day — fecha de inicio en formato DD-MM-YYYY
 * @param {number} day_ranges — rango de días (entero)
 */
export async function compare_analytic_centers(centros, start_day, day_ranges, servidor) {
  const SERVER_URL = servidor;
  const Local ='http://172.16.2.195:7777'

  const endpoint = `${SERVER_URL}/scapp/compare_analytic_centers`
    + `?centros=${centros}`
    + `&start_day=${encodeURIComponent(start_day)}`
    + `&day_ranges=${encodeURIComponent(day_ranges)}`;

  console.log('API compare_analytic_centers ->', endpoint);

  const resp = await fetch(endpoint, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    keepalive: false
  });

  const data = await resp.json();
  if (!resp.ok) {
    throw new Error(data.mensaje || 'Error al comparar centros');
  }
  return data;
}



// https://invermar2.itgchile.com/scapp/last_received_data?centro_id=Loslagos-Puertomontt-Itgcliente
export async function ultima_hora_center(centro, servidor) {
  // console.log('centro', centro);

  const endpoint = `${servidor}/scapp/last_received_data`;
  // Construimos la query con el centro_id
  const params = new URLSearchParams({ centro_id: centro }).toString();

  // console.log('API last_received_data ->', `${endpoint}`);

  const resp = await fetch(`${endpoint}?${params}`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    keepalive: false
  });

  // console.log('resp', resp);
  const data = await resp.json();
  // console.log('data', data);

  if (!resp.ok) {
    throw new Error(data.mensaje || 'Error al obtener hora del centro');
  }
  return data;
}
